import { wines } from './winesData'
import { posts } from './postsData'
import { photos } from './instagramsPhotos'

export const getAllWines = async () => wines
export const getAllPosts = async () => posts
export const getAllPhotos = async () => photos
